(function () {
  /** @param {Element} picker */
  function isPricingRental(picker) {
    var checked = picker.querySelector('input[name^="Pricing"]:checked');
    return checked instanceof HTMLInputElement ? checked.value.toLowerCase() === 'rental' : false;
  }

  /** @param {boolean} rental */
  function selectSupercycleMethod(rental) {
  var selector = rental ? '.supercycle-method--subscription' : '.supercycle-method--resale';

  function trySelect() {
    var method = document.querySelector(selector);
    if (!(method instanceof HTMLElement)) return false;

    var radio = method.querySelector('.supercycle-method__radio');
    var input = method.querySelector('input[type="radio"]');

    // Skip if this method is already the active one — nothing to change
    var alreadySelected = radio && radio.classList.contains('supercycle-method__radio--selected');
    if (alreadySelected) return true;

    document.querySelectorAll('.supercycle-method__radio--selected').forEach(function (el) {
      el.classList.remove('supercycle-method__radio--selected');
    });

    if (radio instanceof HTMLElement) {
      radio.classList.add('supercycle-method__radio--selected');
      radio.click();
    }

    if (input instanceof HTMLInputElement) {
      input.checked = true;
      input.dispatchEvent(new Event('change', { bubbles: true }));
      input.dispatchEvent(new Event('click', { bubbles: true }));
    }

    return !!(radio || input);
  }

  if (trySelect()) return;

  var observer = new MutationObserver(function () {
    if (trySelect()) observer.disconnect();
  });
  observer.observe(document.body, { childList: true, subtree: true });
}

  /** @param {Element} picker */
  function updateBlock(picker) {
    var rental = isPricingRental(picker);
    document.body.classList.toggle('pricing--rental', rental);
    selectSupercycleMethod(rental);
  }

  function hideFirstPayment() {
    function tryHide() {
      var el = /** @type {HTMLElement|null} */ (document.querySelector('.supercycle-summary-line--first-payment'));
      if (!el) return false;
      el.style.display = 'none';
      return true;
    }

    if (tryHide()) return;

    var observer = new MutationObserver(function () {
      if (tryHide()) observer.disconnect();
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  function init() {
    var picker = document.querySelector('variant-picker');
    if (!picker) return;
    updateBlock(picker);
    picker.addEventListener('change', function () { updateBlock(/** @type {Element} */ (picker)); });
    hideFirstPayment();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
